import { render, staticRenderFns } from "./selectSchoolList.vue?vue&type=template&id=96c8920a"
import script from "./selectSchoolList.vue?vue&type=script&lang=js"
export * from "./selectSchoolList.vue?vue&type=script&lang=js"
import style0 from "./selectSchoolList.vue?vue&type=style&index=0&id=96c8920a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports